import {
  ENDED_STATUS,
  CAN_PLAY_STATUS,
  VIDEO_IS_PLAYING_STATUS,
} from './media-event-statuses';
import type { MediaEventState } from './media-event-statuses';

type SetEventAction = { type: 'SET_EVENT'; payload: Record<string, unknown>; scheduleId?: string | number };
type SetStatusAction = { type: 'SET_STATUS'; payload: number; scheduleId?: string | number };
type SetResultsAction = { type: 'SET_RESULTS'; payload: Record<string, unknown> | null; scheduleId?: string | number };
type SetVideoOverlaysAction = { type: 'SET_VIDEO_OVERLAYS'; payload: Record<string, Array<{ value: string; [k: string]: unknown }>> | null; scheduleId?: string | number };
type RemoveEventAction = { type: 'REMOVE_EVENT'; scheduleId?: string | number };
type RemoveResultsAction = { type: 'REMOVE_RESULTS'; scheduleId?: string | number };
type SetErrorAction = { type: 'SET_ERROR'; payload: string | null; scheduleId?: string | number };
type SetActiveScheduleAction = { type: 'SET_ACTIVE_SCHEDULE'; scheduleId: string | number };

export type MediaEventAction =
  | SetEventAction
  | SetStatusAction
  | SetResultsAction
  | SetVideoOverlaysAction
  | RemoveEventAction
  | RemoveResultsAction
  | SetErrorAction
  | SetActiveScheduleAction;

function MediaEventReducer(state: MediaEventState, action: MediaEventAction): MediaEventState {
  if (action.type === 'SET_ACTIVE_SCHEDULE') {
    return { ...state, activeScheduleId: String(action.scheduleId) };
  }

  const actionScheduleId = 'scheduleId' in action && action.scheduleId != null ? String(action.scheduleId) : null;
  if (actionScheduleId != null && state.activeScheduleId != null && actionScheduleId !== state.activeScheduleId) {
    return state;
  }

  switch (action.type) {
    case 'SET_EVENT':
      return {
        ...state,
        event: action.payload,
      };
    case 'SET_STATUS':
      return {
        ...state,
        status: action.payload,
        status_group: {
          HAS_ENDED: ENDED_STATUS.includes(action.payload) ? 1 : 0,
          CAN_PLAY: CAN_PLAY_STATUS.includes(action.payload) ? 1 : 0,
          VIDEO_IS_PLAYING: VIDEO_IS_PLAYING_STATUS.includes(action.payload) ? 1 : 0,
        },
      };
    case 'SET_RESULTS':
      return {
        ...state,
        event_results: action.payload ?? {},
      };
    case 'SET_VIDEO_OVERLAYS':
      if (!action.payload || typeof action.payload !== 'object') {
        return {
          ...state,
          video_overlays: {},
          overlays: {},
        };
      }
      return {
        ...state,
        video_overlays: action.payload,
        overlays: Object.entries(action.payload).reduce<Record<string, unknown[]>>(
          (reduced, [video_id, values]) => {
            const new_values = (values || []).map((item) => {
              const { value, ...rest } = item;
              return {
                ...rest,
                value: typeof value === 'string' ? atob(value) : value,
              };
            });
            reduced[video_id] = new_values;
            return reduced;
          },
          {}
        ),
      };
    case 'REMOVE_EVENT':
      return {
        ...state,
        event: null,
      };
    case 'REMOVE_RESULTS':
      return {
        ...state,
        event_results: null,
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}

export default MediaEventReducer;
